import React, {Component} from 'react';
import StatsBox from "./components/statsBox";
import axios from "axios";

import urls from "../../utils/urls";
import {tokenHeader} from '../../utils/headers';
import _ from "lodash";


export default class DashboardStats extends Component {

    constructor(props) {
        super();
        this.state={
            kpis:false
        }
    }


    componentDidMount() {
        const kpis_url = `${urls.API_ROOT}/api/v1/dashboard/kpi/`;
        axios
            .get(kpis_url, tokenHeader())
            .then((response) => {
                this.setState({
                    kpis:response.data
                })
            })
            .catch(error=>console.log(error));
    }

    render() {
        return <div className="dashboard_gral-stats">
            <div className="row">
                <StatsBox img={"/static/imgs/market.svg"} color={"red"} data={`${_.round(this.state.kpis.shell_ytd_reference_price,2)}%`} comment={"YTD"}
                          text={"Aumento Precio de Referencia"} subtext={"VPN CABA - Shell"} fetchingData={!this.state.kpis}/>
                <StatsBox img={"/static/imgs/raise-blue.svg"} color={"blue"} data={`+${_.round(this.state.kpis.ypf_ytd_pvp,2)}%`} comment={"YTD"}
                          text={"Aumento Precio de Venta al Público"} fetchingData={!this.state.kpis}
                          subtext={"VPN CABA - YPF"}/>
                <StatsBox img={"/static/imgs/alert.svg"} color={"red"} data={`${this.state.kpis.shell_alerts_ammount}`} comment={"bocas"}
                          text={"Desvío entre PVP y Precios Ref."} fetchingData={!this.state.kpis}
                          subtext={"VPN País - Shell"}/>
                <StatsBox img={"/static/imgs/reload.svg"} color={"red"} data={this.state.kpis.shell_last_week_updated}
                          comment={"bocas"} text={"Cambio de PVP últimos 7 días"}
                          subtext={"País - Shell"} fetchingData={!this.state.kpis}/>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/dashboard/stats.js